import { NavItem } from '../../nav/primitives/nav-item';
import { useFormsNavItem } from './use-forms-nav-item';

export const FormsNavItem = () => {
  const item = useFormsNavItem();
  return <NavItem item={item} />;
};
